import React, { createContext, useState, ReactNode } from "react";
import Logger from "../../../utils/Logger";

// Define the shape of the context value
interface MultiStepContextType {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  userData: any;
  setUserData: (data: any) => void;
  submitData: () => void;
}

// Create a default context value
const defaultContextValue: MultiStepContextType = {
  currentStep: 0,
  setCurrentStep: () => {},
  userData: {},
  setUserData: () => {},
  submitData: () => {},
};

// Create the context
export const multiStepContext = createContext<MultiStepContextType | undefined>(
  undefined,
);

// Create a provider component
export const MultiStepProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [userData, setUserData] = useState<any>({
    corporateEmail: "",
    firstName: "",
    lastName: "",
    rollNo: "",
    admissionYear: "",
    educationalQualification: "",
    instituteName: "",
    password: "",
    confirmPassword: "",
  });

  const submitData = () => {
    Logger.info("Submit data:", userData);
    setUserData("");
    setCurrentStep(0);
  };

  return (
    <multiStepContext.Provider
      value={{ currentStep, setCurrentStep, userData, setUserData, submitData }}
    >
      {children}
    </multiStepContext.Provider>
  );
};

export default defaultContextValue;
